/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Tree_Title_Ver_ElementInputs */

const en_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow Your Inner Forest`)
};

const ar_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمِّ غابتك الداخلية`)
};

const de_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass deinen inneren Wald wachsen`)
};

const es_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz crecer tu bosque interior`)
};

const fr_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultivez votre forêt intérieure`)
};

const it_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai crescere la tua foresta interiore`)
};

const ja_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内なる森を育てよう`)
};

const ko_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내면의 숲을 가꾸세요`)
};

const pt_br_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultive sua floresta interior`)
};

const ru_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вырастите свой внутренний лес`)
};

const th_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บ่มเพาะป่าในใจของคุณ`)
};

const tr_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçindeki ormanı büyüt`)
};

const zh_cn_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员独家开运树`)
};

const zh_tw_daily_paywall_tree_title_ver_element = /** @type {(inputs: Daily_Paywall_Tree_Title_Ver_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 獨家開運元樹`)
};

/**
* | output |
* | --- |
* | "Grow Your Inner Forest" |
*
* @param {Daily_Paywall_Tree_Title_Ver_ElementInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_title_ver_element = /** @type {((inputs?: Daily_Paywall_Tree_Title_Ver_ElementInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_Title_Ver_ElementInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "de") return de_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "es") return es_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "it") return it_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "th") return th_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_title_ver_element(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_title_ver_element(inputs)
	return zh_tw_daily_paywall_tree_title_ver_element(inputs)
});